import React, { useState } from "react";
import axios from "axios";
import "./App.css"; // Make sure to import the CSS file

function App() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fcmToken, setFcmToken] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();

    const payload = {
      identifier: email,
      password: password,
      fcm_token: fcmToken,
      device: "Browser",
    };

    try {
      const response = await axios.post(
        "https://6hkmfnqc-4000.euw.devtunnels.ms/api/users/login",
        payload
      );
      console.log("Login successful:", response.data);
    } catch (error) {
      console.error(
        "Login error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  return (
    <div className="App">
      {" "}
      {/* This applies the CSS styles */}
      <form onSubmit={handleLogin}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>FCM Token (optional):</label>
          <input
            type="text"
            value={fcmToken}
            onChange={(e) => setFcmToken(e.target.value)}
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default App;
